import React, { useState } from "react";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { toast } from "sonner";
import { api, formatApiErrorDetail } from "@/lib/api";
import AuthLayout, { Field, inputCls } from "@/pages/AuthLayout";

export default function ResetPassword() {
  const [params] = useSearchParams();
  const token = params.get("token") || "";
  const navigate = useNavigate();
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      await api.post("/auth/reset-password", { token, password });
      toast.success("Passphrase updated. Please sign in.");
      navigate("/login");
    } catch (err) {
      toast.error(formatApiErrorDetail(err.response?.data?.detail) || err.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <AuthLayout
      title="Set New Passphrase"
      subtitle="Choose a strong new passphrase to secure your dossier."
      footer={<Link to="/login" className="text-[#F1551D] hover:underline">Back to sign in</Link>}
    >
      {!token ? (
        <p className="text-center text-rose-300 text-sm" data-testid="reset-invalid">This reset link is invalid or incomplete.</p>
      ) : (
        <form onSubmit={submit}>
          <Field label="New Passphrase (min 6 chars)">
            <input data-testid="reset-password-input" type="password" required minLength={6} value={password} onChange={(e) => setPassword(e.target.value)} className={inputCls} placeholder="••••••••" />
          </Field>
          <button data-testid="reset-submit-btn" disabled={loading} className="w-full py-2.5 rounded-lg btn-gold font-semibold disabled:opacity-60">
            {loading ? "Updating…" : "Update Passphrase"}
          </button>
        </form>
      )}
    </AuthLayout>
  );
}
